/**
 * Copyright © 2026 Adnuntius AS.
 *
 * List/query column-option popovers and select-in filters.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {PopoverModule} from 'ngx-bootstrap/popover';

import {AppSharedModule} from '../app-shared.module';
import {ListColumnSelectorComponent} from './list-column-selector.component';
import {QueryColumnSelectorComponent} from './query-column-selector.component';
import {ListSelectInFilterComponent} from '../directives/list-select-in-filter.component';

const LIST_COLUMN_SELECTORS = [
  ListColumnSelectorComponent,
  QueryColumnSelectorComponent,
  ListSelectInFilterComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    PopoverModule
  ],
  declarations: LIST_COLUMN_SELECTORS,
  exports: LIST_COLUMN_SELECTORS
})
export class ListColumnSelectorsModule {
}
